import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatTooltip} from '@angular/material/tooltip';
import dayjs from 'dayjs';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs';
import {DateRangeForm, DateRangeFormValue} from '../../../../../../components/date-range-picker-field/date-range-picker-field.component';
import {ClassificationColumn} from '../classification-table.component';

@Component({
    selector: 'af-classification-table-header',
    standalone: false,
    templateUrl: './classification-table-header.component.html',
})
export class ClassificationTableHeaderComponent implements OnInit {
    @ViewChild('tooltip') tooltip!: MatTooltip;
    @Input() column: ClassificationColumn;
    @Output() dateRangeChanged = new EventEmitter<DateRangeFormValue>();
    tooltipText: string;
    form: FormGroup<DateRangeForm>;
    startDate: dayjs.Dayjs;
    endDate: dayjs.Dayjs;
    minDate = dayjs().subtract(3, 'months').startOf('months');
    maxDate = dayjs().subtract(1, 'months').endOf('months');
    headerPostfix: string;

    constructor(private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.headerPostfix = this.column;
        if (this.column === 'month' || this.column === 'forecastPast') {
            this.endDate = dayjs().subtract(1, 'month').endOf('month');
            this.startDate = this.endDate.startOf('month');
        }
        if (this.column === 'quarter') {
            this.endDate = dayjs().subtract(1, 'month').endOf('month');
            this.startDate = this.endDate.subtract(2, 'months').startOf('month');
        }
        if (this.column === 'forecastFuture') {
            this.endDate = dayjs().endOf('month');
            this.startDate = this.endDate.startOf('month');
        }
        this.form = this.formBuilder.group({});
        this.form.valueChanges
            .pipe(
                debounceTime(300),
                distinctUntilChanged(),
                filter(value => !!value.dateFrom && !!value.dateTo),
            )
            .subscribe(value => {
                this.headerPostfix =
                    ['month', 'quarter'].includes(this.column)
                        ? getPostfixByDateRange(dayjs(value.dateFrom), dayjs(value.dateTo))
                        : this.column;
                if (['forecastFuture', 'forecastPast', 'customRange'].includes(this.headerPostfix)) {
                    this.tooltipText = `i18n_af_tooltipClassificationTableHeader#${this.headerPostfix}`;
                } else {
                    this.tooltipText = undefined;
                }
                this.dateRangeChanged.emit(value);
            });
    }
}

export function getPostfixByDateRange(start: dayjs.Dayjs, end: dayjs.Dayjs): string {
    let months = 0;
    let current = start.clone();

    while (current.add(1, 'month').isSame(end.add(1, 'day'), 'day') || current.add(1, 'month').isBefore(end, 'day')) {
        months++;
        current = current.add(1, 'month');
    }

    if (months === 3) {
        return 'quarter';
    } else if (months === 1) {
        return 'month';
    } else {
        return 'customRange';
    }
}
